// src/services/brandingService.js
// Servicio de personalizacion de marca por workspace
import { doc, getDoc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { db, storage } from './firebase';

const DEFAULT_BRANDING = {
  logo: '',
  logoSmall: '',
  companyName: '',
  primaryColor: '#6366f1', // indigo-500
  accentColor: '#8b5cf6',  // violet-500
  sidebarColor: '#1e1b4b', // indigo-950
  customDomain: '',
};

/**
 * Obtener branding del workspace
 */
export const getWorkspaceBranding = async (workspaceId) => {
  const snap = await getDoc(doc(db, 'workspaces', workspaceId));
  if (!snap.exists()) return DEFAULT_BRANDING;
  const data = snap.data();
  return {
    ...DEFAULT_BRANDING,
    companyName: data.name || '',
    ...data.branding,
  };
};

/**
 * Guardar branding del workspace
 */
export const saveWorkspaceBranding = async (workspaceId, branding) => {
  await updateDoc(doc(db, 'workspaces', workspaceId), {
    branding: {
      logo: branding.logo || '',
      logoSmall: branding.logoSmall || '',
      primaryColor: branding.primaryColor || DEFAULT_BRANDING.primaryColor,
      accentColor: branding.accentColor || DEFAULT_BRANDING.accentColor,
      sidebarColor: branding.sidebarColor || DEFAULT_BRANDING.sidebarColor,
      customDomain: branding.customDomain || '',
    },
    updatedAt: serverTimestamp(),
  });
};

/**
 * Subir logo del workspace a Firebase Storage
 */
export const uploadWorkspaceLogo = async (workspaceId, file, type = 'logo') => {
  const ext = file.name.split('.').pop();
  const path = `workspaces/${workspaceId}/${type}.${ext}`;
  const storageRef = ref(storage, path);
  await uploadBytes(storageRef, file);
  const url = await getDownloadURL(storageRef);
  return url;
};

/**
 * Generar CSS custom properties a partir del branding
 */
export const generateBrandingCSS = (branding) => {
  if (!branding) return {};
  return {
    '--brand-primary': branding.primaryColor || DEFAULT_BRANDING.primaryColor,
    '--brand-accent': branding.accentColor || DEFAULT_BRANDING.accentColor,
    '--brand-sidebar': branding.sidebarColor || DEFAULT_BRANDING.sidebarColor,
  };
};

/**
 * Colores predefinidos para elegir
 */
export const COLOR_PRESETS_BRAND = [
  { name: 'Indigo', primary: '#6366f1', accent: '#8b5cf6', sidebar: '#1e1b4b' },
  { name: 'Azul', primary: '#3b82f6', accent: '#60a5fa', sidebar: '#172554' },
  { name: 'Esmeralda', primary: '#10b981', accent: '#34d399', sidebar: '#022c22' },
  { name: 'Rosa', primary: '#ec4899', accent: '#f472b6', sidebar: '#500724' },
  { name: 'Ambar', primary: '#f59e0b', accent: '#fbbf24', sidebar: '#451a03' },
  { name: 'Rojo', primary: '#ef4444', accent: '#f87171', sidebar: '#450a0a' },
  { name: 'Cyan', primary: '#06b6d4', accent: '#22d3ee', sidebar: '#083344' },
  { name: 'Violeta', primary: '#8b5cf6', accent: '#a78bfa', sidebar: '#2e1065' },
  { name: 'Slate', primary: '#64748b', accent: '#94a3b8', sidebar: '#0f172a' },
  { name: 'Negro', primary: '#374151', accent: '#6b7280', sidebar: '#111827' },
];
